import { EntityIdAliasPrefixes } from '@abb-procure/constants';
import { InvitedUserModel } from '@abb-procure/data';
import { BooleanInput } from '@angular/cdk/coercion';
import { Component, booleanAttribute, input, output } from '@angular/core';
import { InvitedUser } from '../invited-user/invited-user.component';
import { ShowField } from '../show-field/show-field.component';

@Component({
  selector: 'procure-invited-users',
  templateUrl: './invited-users.component.html',
  styleUrl: './invited-users.component.scss',
  imports: [ShowField, InvitedUser],
})
export class InvitedUsers {
  readonly users = input.required<InvitedUserModel[]>();
  readonly entityType = input.required<EntityIdAliasPrefixes>();
  readonly entityId = input<string>();

  readonly canRemove = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly remove = output<void>();
}
